import Image from 'next/image'

export default function Hero({city='',slug=''}:any) {
  // Breadcrumbs: always Home, optionally city
  const breadcrumbs = [
    { name: 'Startseite', href: '/' },
    ...(city ? [{ name: city, href: `/${slug.toLowerCase()}` }] : [])
  ];
  // BreadcrumbList schema
  const origin =
    typeof window !== 'undefined'
      ? window.location.origin
      : process.env.NEXT_PUBLIC_SITE_URL || 'https://autoverwertungs.de';

  const breadcrumbItems = breadcrumbs.map((crumb, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: crumb.name,
    item: origin + crumb.href
  }));

  return (
    <section className="relative text-white py-12 md:py-24 lg:py-32 min-h-[400px] md:min-h-[500px] flex items-center justify-center overflow-hidden">
      {/* BreadcrumbList Schema.org LD+JSON */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbItems
          })
        }}
      />
      {/* Background Image */}
      <Image
        src="/images/cars/hero.webp"
        alt="Autoverwertung Hintergrund"
        fill
        priority
        quality={90}
        sizes="100vw"
        className="absolute inset-0 object-cover -z-10"
        fetchPriority="high"
      />
      
    {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#003d99]/80 to-[#0066CC]/50 -z-10" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Breadcrumb */}
        <nav className="mb-6" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-2 text-sm md:text-base text-white/80">
            {breadcrumbs.map((crumb, idx) => (
              <li key={crumb.href} className="flex items-center">
                <a href={crumb.href} className={idx === breadcrumbs.length - 1 ? 'font-bold text-white' : 'hover:underline'} aria-current={idx === breadcrumbs.length - 1 ? 'page' : undefined}>
                  {crumb.name}
                </a>
                {idx < breadcrumbs.length - 1 && (
                  <span className="mx-2 text-white/50">/</span>
                )}
              </li>
            ))}
          </ol>
        </nav>
        <div className="max-w-4xl animate-fadeIn">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4">
            Autoverwertung {city && `in ${city}`}
          </h1>
          <p className="text-base sm:text-lg md:text-xl mt-4 max-w-2xl leading-relaxed">
           Kfz-Ankauf {city && `in ${city}`}.  Wir holen Ihr Auto ab, kümmern uns um Papiere und garantieren umweltgerechte Verwertung.
          </p>
                     <div className="flex items-start gap-1 mb-2">
                          <span className="text-yellow-400 text-2xl">★★★★★</span>
                      </div>
                      <p className="text-sm md:text-base text-white/90 font-medium">
                          Über 500 Kunden bewerten uns mit 5 Sternen – mehr als 3.000 Autos erfolgreich angekauft.
                      </p>
          <div className="mt-6 md:mt-8 flex gap-4 flex-col sm:flex-row">
            <button
              className="bg-[#0066CC] hover:bg-[#004BA6] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg focus:outline-none"
              onClick={() => {
                const form = document.getElementById('contact-form');
                if (form) {
                  form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
              onMouseEnter={e => e.currentTarget.classList.add('animate-bounce')}
              onMouseLeave={e => e.currentTarget.classList.remove('animate-bounce')}
            >
              Kontaktformular
            </button>
            <a
              href={`tel:${process.env.NEXT_PUBLIC_PHONE_NUMBER || ''}`}
              className="flex items-center gap-3 border-2 border-white hover:bg-white hover:text-[#0066CC] text-white px-6 py-3 rounded-lg font-bold text-xl shadow-lg transition-all duration-300 inline-block hover:scale-105 focus:outline-none animate-pulse"
              style={{ letterSpacing: '0.05em' }}
              onMouseEnter={e => e.currentTarget.classList.add('animate-bounce')}
              onMouseLeave={e => e.currentTarget.classList.remove('animate-bounce')}
              aria-label={`Jetzt anrufen: ${process.env.NEXT_PUBLIC_PHONE_NUMBER}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15l2.25-2.25a1.5 1.5 0 0 0 0-2.121l-3.75-3.75a1.5 1.5 0 0 0-2.121 0l-1.125 1.125a11.25 11.25 0 0 1-5.25-5.25l1.125-1.125a1.5 1.5 0 0 0 0-2.121l-3.75-3.75a1.5 1.5 0 0 0-2.121 0L2.25 6.75z" />
              </svg>
              <span className="tracking-wider">
                <span className="text-green-400 font-bold">Jetzt anrufen:</span> <span className="ml-1 text-[#FFD700] drop-shadow-lg">{process.env.NEXT_PUBLIC_PHONE_NUMBER}</span>
              </span>
            </a>
          </div>
          
          {/* Trust Indicator */}

        </div>
      </div>
    </section>
  )
}
